<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { Activity } from 'lucide-vue-next'

const appVersion = __APP_VERSION__

const autoUpdateActive = ref(true)

function onVisibility() {
  autoUpdateActive.value = !document.hidden
}

onMounted(() => document.addEventListener('visibilitychange', onVisibility))
onUnmounted(() => document.removeEventListener('visibilitychange', onVisibility))
</script>

<template>
  <footer class="fixed bottom-0 left-0 right-0 z-[100] h-[2.2em] bg-sh-menu backdrop-blur-xl border-t border-sh-glass-border flex items-center justify-between px-[1em] text-[0.75em] text-sh-text-muted">
    <span class="text-sh-amber font-semibold tracking-wide">Home {{ appVersion }}</span>
    <span class="flex items-center gap-[0.4em]">
      <Activity :size="12" :class="autoUpdateActive ? 'text-sh-green' : 'text-sh-red'" />
      <span :class="autoUpdateActive ? 'text-sh-green' : 'text-sh-red'">{{ autoUpdateActive ? 'Live' : 'Pausiert' }}</span>
    </span>
    <router-link to="/impress" data-testid="nav-impress" class="text-sh-text-muted hover:text-sh-accent no-underline transition-colors">
      Impressum
    </router-link>
  </footer>
</template>
